import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

const icons = {
    RequestQuoteIcon,
    AssignmentTurnedInIcon,
};

const invoicingFinGroup = {
    id: "invoice_finance",
    title: "Invoicing",
    type: "group",
    icon: icons.RequestQuoteIcon,
    children: [
        {
            id: "invoice_finance_1",
            title: "Invoice",
            type: "item",
            url: "/invoice",
            icon: icons.RequestQuoteIcon,
        },
        {
            id: "assign_billing_finance_1",
            title: "Assign Billing Type",
            type: "item",
            url: "/Assign_Billing_Type",
            icon: icons.AssignmentTurnedInIcon,
        },
    ],
};

export default invoicingFinGroup;